<template>
    <page-layout bg-background="black">
        <b-card no-body class="unsubscribe-card">
            <slot></slot>
        </b-card>
    </page-layout>
</template>
<script>
import { defineComponent } from 'vue';
import PageLayout from '@components/Layout/PageLayout.vue';

export default defineComponent({
    components: {
        PageLayout,
    },
    unmounted() {
        this.toggleBodyClass(false);
    },
    mounted() {
        this.toggleBodyClass(true);
    },
    methods: {
        toggleBodyClass: function (add) {
            const el = document.body;
            if (add) {
                el.classList.add('unsubscribe-page');
            } else {
                el.classList.remove('unsubscribe-page');
            }
        },
    }
});
</script>
<style lang="scss" scoped>
.unsubscribe-card {
    background: rgba(0, 0, 0, 0.8);
    margin: 0 auto;
    width: 100%;
    max-width: 500px;
    border-radius: 0;
    color: #ffffff;
    padding: 3rem 1rem 1rem;

    &--init {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
}

::v-deep .btn-white {
    background: white;
    margin-bottom: 1rem;
    padding: .75rem 1rem;
}

::v-global(.unsubscribe-page .page-wrapper) {
    background: #080808 !important;
    background-image: url(/images/unsubscribe-bg.jpg) !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    box-shadow: inset 0 0 0 100vmax rgba(0, 0, 0, 0.2);
}

::v-global(.unsubscribe-page .page-header) {
    display: none !important;
    background: white;
    margin-bottom: 2rem;
}

::v-global(.unsubscribe-page .content) {
    padding: 1.5rem;
    padding-top: 0;
}
</style>
